import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import { Button, Row, Col, Input, Label, Table, ButtonGroup } from "reactstrap";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Swal from "sweetalert2";

function ListadoRecepcionesLaredo() {
  const { user } = useContext(AuthContext);
  const URL_RL = process.env.REACT_APP_URL_RECEPCIONES_LAREDO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(moment(inicio).format("YYYY-MM-DD"));
  const [selectedFechaFin, setSelectedFechaFin]       = useState(moment(hoy).format("YYYY-MM-DD"));

  const [recepciones, setRecepciones] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  const headers = [
    { name: "#",          field: "idRecepcionLaredo",  sortable: true },
    { name: "Fecha",      field: "fecha",               sortable: true },
    { name: "Proveedor",  field: "proveedor",           sortable: true },
    { name: "OC #",       field: "idOrdenCompra",       sortable: true },
    { name: "Factura",    field: "noFactura",           sortable: true },
    { name: "Guía",       field: "noGuia",              sortable: true },
    { name: "TC",         field: "tipoCambio",          sortable: true },
    { name: "Piezas",     field: "total_cantidad",      sortable: true },
    { name: "Total USD",  field: "total_general",       sortable: true },
    { name: "Acciones",   field: "",                    sortable: false },
  ];

  useEffect(() => { jalaRecepciones(); }, []);

  function jalaRecepciones() {
    showLoader();
    axios.get(`${URL_RL}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } })
      .then(({ data }) => {
        const rows = data.map(r => ({
          _id: r._id,
          idRecepcionLaredo: r.idRecepcionLaredo,
          fecha: r.fecha,
          proveedor: r.ordenesCompra?.[0]?.proveedores?.[0]?.nombre_comercial || "",
          idOrdenCompra: r.ordenesCompra?.[0]?.idOrdenCompra || "",
          idOC: r.ordenesCompra?.[0]?._id || "",
          noFactura: r.noFactura,
          noGuia: r.noGuia,
          tipoCambio: r.tipoCambio,
          total_cantidad: r.total_cantidad,
          total_general: r.total_general,
          is_active: r.is_active,
        }));
        setRecepciones(rows);
        hideLoader();
      })
      .catch(err => { console.log(err); hideLoader(); });
  }

  const commentsData = useMemo(() => {
    let filtered = recepciones;
    if (search) {
      filtered = filtered.filter(r =>
        r.proveedor.toLowerCase().includes(search.toLowerCase()) ||
        String(r.idRecepcionLaredo).includes(search) ||
        (r.noFactura || "").toLowerCase().includes(search.toLowerCase())
      );
    }
    setTotalItems(filtered.length);
    if (sorting.field) {
      filtered = [...filtered].sort((a, b) =>
        sorting.order === "asc"
          ? a[sorting.field] > b[sorting.field] ? 1 : -1
          : a[sorting.field] < b[sorting.field] ? 1 : -1
      );
    }
    return filtered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  }, [recepciones, search, sorting, currentPage]);

  function bajasRecepcion(id) {
    Swal.fire({ title: "¿Eliminar?", icon: "warning", showCancelButton: true, confirmButtonText: "Sí" })
      .then(res => {
        if (res.isConfirmed) {
          axios.delete(`${URL_RL}/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } })
            .then(() => jalaRecepciones());
        }
      });
  }

  return (
    <>
      <Header />
      <br /><br />
      {user.menu_compras ? (
        <div className="card col-12">
          {/* Botones superiores */}
          <Row>
            <Col md={8}>
              <Button size="sm" color="danger" href="/BotonesCompras" id="botonListado">
                Regresar
              </Button>
            </Col>
          </Row>

          {/* Título */}
          <h3 align="center">Recepciones en Bodega USA</h3>

          {/* Paginación izquierda / Search derecha */}
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={p => setCurrentPage(p)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search onSearch={v => { setSearch(v); setCurrentPage(1); }} />
            </div>
          </div>

          {/* Filtros de fecha */}
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input bsSize="sm" type="date" value={selectedFechaInicio}
                onChange={e => setSelectedFechaInicio(e.target.value)} />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input bsSize="sm" type="date" value={selectedFechaFin}
                onChange={e => setSelectedFechaFin(e.target.value)} />
            </Col>
            <Col md={2} className="d-flex align-items-end">
              <Button size="sm" color="info" onClick={jalaRecepciones}>Buscar</Button>
            </Col>
          </Row>
          <br />

          {/* Tabla */}
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader headers={headers} onSorting={(f, o) => setSorting({ field: f, order: o })} />
            <tbody>
              {commentsData.map(r => (
                <tr key={r._id}>
                  <td>{r.idRecepcionLaredo}</td>
                  <td>{r.fecha}</td>
                  <td>{r.proveedor}</td>
                  <td>{r.idOrdenCompra}</td>
                  <td>{r.noFactura}</td>
                  <td>{r.noGuia}</td>
                  <td>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(r.tipoCambio)}</td>
                  <td>{new Intl.NumberFormat("en-US").format(r.total_cantidad)}</td>
                  <td>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(r.total_general)}</td>
                  <td>
                    <Button size="sm" color="success" href={`/ComprasCreate?rl=${r._id}`}>
                      Crear Entrada
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={p => setCurrentPage(p)}
            />
          </div>
        </div>
      ) : <p className="text-muted ms-3">Sin acceso.</p>}
      {loader}
    </>
  );
}

export default ListadoRecepcionesLaredo;
